import React from 'react';
import { Layout, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  DashboardOutlined,
  ContactsOutlined,
  FolderOutlined,
  UserOutlined,
  MailOutlined,
  CalendarOutlined,
  ShareAltOutlined,
  SettingOutlined
} from '@ant-design/icons';

const { Sider } = Layout;

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Tableau de bord',
    },
    {
      key: '/contacts',
      icon: <ContactsOutlined />,
      label: 'Contacts',
    },
    {
      key: '/families',
      icon: <FolderOutlined />,
      label: 'Familles',
    },
    {
      key: '/events',
      icon: <CalendarOutlined />,
      label: 'Événements',
    },
    {
      key: '/shares',
      icon: <ShareAltOutlined />,
      label: 'Partages',
    },
    {
      key: '/emails',
      icon: <MailOutlined />,
      label: 'Emails',
    },
    {
      type: 'divider',
    },
    {
      key: '/profile',
      icon: <UserOutlined />,
      label: 'Profil',
    },
  ];

  return (
    <Sider
      width={250}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <div className="sidebar-logo">
        Gestion Contacts
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={({ key }) => navigate(key)}
      />
    </Sider>
  );
};

export default Sidebar;
